export interface HistoryOrder {
  id: number
  formId?: number | null
  formName?: string | null
  customerName?: string | null
  dateModified?: string
  placedAt: string
  placedByName?: string | null
  status?: string | null
}

export interface OrderHistoryGroup {
  formId: number
  formName: string
  lastPlacedAt: string
  orders: HistoryOrder[]
}

function placedTime(value: string) {
  const time = Date.parse(value)
  return Number.isNaN(time) ? 0 : time
}

export function groupOrdersByForm(orders: HistoryOrder[]): OrderHistoryGroup[] {
  const groups = new Map<number, HistoryOrder[]>()
  for (const order of orders) {
    const formId = order.formId ?? 0
    const list = groups.get(formId) ?? []
    list.push(order)
    groups.set(formId, list)
  }

  return [...groups.entries()]
    .map(([formId, rows]) => {
      const sorted = [...rows].sort((a, b) => placedTime(b.placedAt) - placedTime(a.placedAt))
      const named = sorted.find((order) => order.formName?.trim())
      return {
        formId,
        formName: named?.formName?.trim() || 'Submission',
        lastPlacedAt: sorted[0]?.placedAt ?? '',
        orders: sorted,
      }
    })
    .sort((a, b) => placedTime(b.lastPlacedAt) - placedTime(a.lastPlacedAt))
}
